<template>
    <div>
        <vx-tooltip id="printSelectedReturnLabels" class="vs-con-loading__container" :text="getToolTipText()">
            <vs-button color="#333333" @click.native="selectedPrintReturnLabels" :disabled="isButtonDisabled()">
                <font-awesome-icon :icon="['fas', 'print']" class="fa-icon" />
            </vs-button>
        </vx-tooltip>
    </div>
</template>

<script>
import dymoPrinter from '../../services/dymo/dymoPrinter';

export default {
	props: {
		dymoPrinter: {
			type: dymoPrinter,
			required: true,
		}
	},
	methods: {
		getToolTipText() {
			if (this.$parent.getSelectedOrdersCount() === 0) {
				return 'Er is geen bestelling geselecteerd'
			}

			if (!this.dymoPrinter.returnPrinterReady()) {
				return 'Er is geen verbinding met de retour label printer';
			}

			if (this.$parent.getSelectedOrdersCount() === 1) {
				return 'Print retour label';
			}

			return 'Print retour labels';
		},
		isButtonDisabled() {
			if (!this.dymoPrinter.returnPrinterReady()) {
				return true;
			}

			return this.$parent.getSelectedOrdersCount() === 0;
		},
		selectedPrintReturnLabels() {
			if (this.isButtonDisabled()) {
				return;
			}

			this.startLoading();

			const selectedOrdersAmount = this.$parent.getSelectedOrdersCount();

			this.dymoPrinter.printReturnLabel(selectedOrdersAmount).then(response => {
				this.stopLoading();
			}).catch(error => {
				this.stopLoading();
			});
		},
		startLoading() {
			this.$vs.loading({
				container: '#printSelectedReturnLabels',
				scale: 0.45
			})
		},
		stopLoading() {
			this.$vs.loading.close('#printSelectedReturnLabels > .con-vs-loading')
		}
	}

}
</script>
